<template>
  <Layout
    class="onboarding-daily-goal"
    :title="page.title"
    :subtitle="page.subtitle"
  >
    <DailyGoalWheel
      v-if="platform.isTouchScreen()"
      class="onboarding-daily-goal__wheel"
      :view="view"
    />
    <DailyGoalSlider
      v-else
      class="onboarding-daily-goal__slider"
      :view="view"
    />
  </Layout>
</template>

<script setup lang="ts">
import { computed, onBeforeMount } from 'vue'

import { platform } from '@/services/platform'
import { QuestionnaireView } from '@/models/onboarding'
import { DailyGoalPage } from '@/models/onboarding.types'
import { PublicInterface } from '@/models/interfaces'

import Layout from '../Layout.vue'
import DailyGoalWheel from '../DailyGoalWheel.vue'
import DailyGoalSlider from '../DailyGoalSlider.vue'

const props = defineProps<{
  view: PublicInterface<QuestionnaireView>
}>()

const page = computed(() => {
  return props.view.currentPage as DailyGoalPage
})

onBeforeMount(async () => {
  // Set the default value to 20.
  props.view.setCurrentChoice(20)
})
</script>

<style lang="scss" scoped>
.onboarding-daily-goal {
  :deep(.onboarding-layout__default-slot) {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    margin-top: var(--onboarding-padding);
  }
}
</style>
